
<router-link
    class="Nav-Link"
    :to="route"
    @click.native="$emit('click')"
    v-tooltip="isCollapsed && tooltip ? tooltip : ''"
>
    <i :class="icon"></i>
    <span>{{ displayLabel }}</span>
</router-link>
